module.exports = __webpack_public_path__ + "fonts/Roboto-Light.35d8503.eot";